import Splide from "@splidejs/splide";
import LazyImage from "../core/LazyImage";
import LazyVideo from "../core/LazyVideo";

export default new class Slideshows {
    init() {
		this.initSlideshows();
	}

    initSlideshows() {
        if(document.querySelectorAll('.js-splide-articles')) {
            document.querySelectorAll('.js-splide-articles').forEach((splide) => {
                const splideArticle = new Splide(splide, {
                    type : 'loop',
                    autoplay: true,
                    interval: 0,
                    speed: 180000,
                    arrows : false,
                    pagination : false,
                    perPage : 4,
					perMove : 1,
                    focus : 'center',
                    drag : true,
                    gap : 40,
                    pauseOnHover: false,
                    pauseOnFocus: false, 
                    breakpoints : {
                        1279: {
                            perPage : 3,
                        },
                        899: {
                            perPage : 2,
                        },
                        767: {
                            gap : 20,
                        },
                        575: {
                            perPage : 1.5,
                            autoplay: false, 
                            speed   : 600 
                        },
					}                
                });

                splideArticle.on('mounted', () => {
                   LazyImage.init();
                   LazyVideo.init();
                });

                splideArticle.mount();
            });
        }

        if(document.querySelectorAll('.js-splide-gallery')) {
            document.querySelectorAll('.js-splide-gallery').forEach((splide) => {
                new Splide(splide, {
                    type : 'loop',
                    autoplay: true,
                    interval: 0,
                    speed: 100000,
                    arrows : false,
                    pagination : false,
                    perMove : 1,
                    focus : 'center',
                    drag : true,
                    autoWidth : true,
                    gap : 40,
                    breakpoints : {
                        767: {
                            gap : 20,
                        },
                        575: {
                            perPage : 1.5,
                            autoplay: false, 
                            speed   : 600 
                        },
					} 
                }).mount();
            });
        }
        
        if(document.querySelectorAll('.js-splide-testimonials')) {
            document.querySelectorAll('.js-splide-testimonials').forEach((splide) => {
                new Splide(splide, {
                    type : 'loop',
                    autoplay: 4000,
                    interval: 4000,
                    speed: 2000,
                    arrows : false,
                    pagination : false,
                    perMove : 1,
                    focus : 'center', 
                    drag : true,
                    autoWidth : true,
                    gap : 40,
                    breakpoints : {
                        767: {
                            gap : 20,
                        },
                        575: {
                            perPage : 1.5,
                            autoplay: false, 
                            speed   : 600 
                        },
					} 
                }).mount();
            });
        }
    }
}